import {connect} from "react-redux";
import View from "./view";
import {bindActionCreators} from "redux";
import {proposalCommercialClosure} from "../../../service/Opportunities/action";
const mapStateToProps = (state) => ({
    proposalCommercialDetails:state.Opportunitie.proposalCommercialDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            proposalCommercialClosure
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(View);
